module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "author"
  }, [_vm._l(((_vm.expand ? _vm.all : _vm.left)), function(a) {
    return _c('div', {
      class: ['ava', {
        squeeze: _vm.expand
      }],
      style: ({
        'background-image': _vm.url(a.ava)
      }),
      attrs: {
        "title": a.name
      }
    })
  }), _vm._v(" "), (!_vm.expand) ? _c('span', {
    staticClass: "more"
  }, [_vm._v("\n    и "), _c('a', {
    on: {
      "click": function($event) {
        _vm.expand = true
      }
    }
  }, [_vm._v("ещё " + _vm._s(_vm.rightCount))])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c100fd38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/parts/attendees.vue
// module id = 162
// module chunks = 1